<div class="card overflow-hidden rounded-10 shadow">
  <div class="card-body" *ngIf="isLoaded">
    <app-loading-dash [size]="'card-middle'" />
  </div>
  <div class="card-body" *ngIf="!isLoaded">
    <div class="card-widget">
      <h6 class="mb-3">{{ 'common.receiptConversion' | translate }}</h6>
      <h2 class="text-end">
        <i class="fa fa-cart-plus icon-size float-start purple-color"></i
        ><span class="number-font"
          >{{
            convert
              | mask : "separator.2" : { decimalMarker: ",", leadZero: true }
          }}%</span
        >
      </h2>
      <p class="mb-0">
        (%) {{ 'common.fromLastWeek' | translate }}<span class="float-end"
          >{{
            lastConvert
              | mask : "separator.2" : { decimalMarker: ",", leadZero: true }
          }}%</span
        >
      </p>
    </div>
  </div>
</div>
